import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'
import docpc from './modules/docpc'
import publicWelfareStaff from './modules/publicWelfareStaff'
import {doctor} from './doctor/index'
import {
  Dialog,
} from "vant";
Vue.use(Dialog);

try {
  createPersistedState()
} catch (e) {
  Dialog.alert({
    message: '您的浏览器可能处于无痕模式，请切换浏览器模式后再重新打开本页面'
  })
}

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    patientOne: null, //患者第一阶段信息
    isLoading: false,
    direction: 'forward',
    userInfo: null,
    url: null,
    title: null,
    lecture: null,
    to: 1,
    patientInfo: null,
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo;
    },
    getPatientOne(state) {
      return state.patientOne;
    },
    getPatientInfo(state) {
      return state.patientInfo;
    },
    getPapid(state) {
      return state.userInfo.patient.papid
    },
    getAddUploadStatus(state) {
      return state.publicWelfareStaff.addUploadStatus
    },
    getFrontStatus(state) {
      return state.publicWelfareStaff.front_status
    }

  },
  mutations: {
    updateLoadingStatus(state, payload) {
      state.isLoading = payload.isLoading
    },
    updateDirection(state, payload) {
      state.direction = payload.direction
    },
    setPatientInfo(state, patientInfo) {
      state.patientInfo = patientInfo;
    },
    setUserInfo(state, payload) {
      if (state.userInfo === null) {
        state.userInfo = payload.userInfo
      } else {
        Object.assign(state.userInfo, payload.userInfo)
      }
    },
    clearUserInfo(state) {
      state.userInfo = null
    },
    setUrl(state, payload) {
      state.url = payload
    },
    setTitle(state, payload) {
      state.title = payload
    },
    setLecture(state, payload) {
      state.lecture = payload.lecture
    },
    setTo(state, payload) {
      state.to = payload
    },
    setPatientOne(state, payload) {
      state.patientOne = payload.patientOne
    },
    clearPatientOne(state) {
      state.patientOne = null;
    }
  },
  actions: {
    setUserInfo(context) {
      context.commit('setUserInfo')
    },
    setPatientOne(context) {
      context.commit('setPatientOne')
    },
    clearPatientOne(context) {
      context.commit('clearPatientOne');
    }
  },
  modules: {
    docpc,
    doctor,
    publicWelfareStaff,
  },
  plugins: [createPersistedState()],
});